import { TabType } from './types'

interface TabNavigationProps {
  activeTab: TabType
  onTabChange: (tab: TabType) => void
}

export function TabNavigation({ activeTab, onTabChange }: TabNavigationProps) {
  const tabs: { id: TabType; label: string; count: string }[] = [
    { id: 'basic', label: 'Basic', count: '11' },
    { id: 'drums', label: 'Drums', count: '10' },
    { id: 'melody', label: 'Melody', count: '9' },
    { id: 'advanced', label: 'Advanced', count: '10' },
  ]

  return (
    <div className="flex gap-1 border-b border-white/5 mb-4">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabChange(tab.id)}
          className={`px-4 py-2 text-sm font-medium transition-colors relative ${
            activeTab === tab.id
              ? 'text-primary-400 border-b-2 border-primary-500'
              : 'text-gray-400 hover:text-gray-300'
          }`}
        >
          {tab.label}
          <span className="ml-1.5 text-xs opacity-60">({tab.count})</span>
          {activeTab === tab.id && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500" />
          )}
        </button>
      ))}
    </div>
  )
}
